// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    0,
    {
      "sub": "通信新技术",
      "tec": "丁伟",
      "week": "5-6,9-18周",
      "add": "实训楼F座202自控"
    },
    0,
    0,
    0
  ],
  "2": [
    0,
    0,
    0,
    0,
    0
  ],
  "3": [
    0,
    0,
    0,
    0,
    0
  ],
  "4": [
    0,
    0,
    0,
    0,
    0
  ],
  "5": [
    0,
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
